//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './HL7MessageTypeMappingClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';


export type GetSingleHL7MessageTypeMappingQueryParameters = {
  id: number ;
}

export type PatchHL7MessageTypeMappingQueryParameters = {
  id: number ;
}

export type RemoveHL7MessageTypeMappingQueryParameters = {
  id: number ;
}

export function getAllUrl(): string {
  let url_ = getBaseUrl() + "/api/hl7/message-type-mappings";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getAllDefaultOptions: Omit<UseQueryOptions<Types.HL7MessageTypeMappingDto[], unknown, Types.HL7MessageTypeMappingDto[]>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.HL7MessageTypeMappingDto[], unknown, Types.HL7MessageTypeMappingDto[]>, 'queryFn'>> = {
};
export function getGetAllDefaultOptions() {
  return getAllDefaultOptions;
};
export function setGetAllDefaultOptions(options: typeof getAllDefaultOptions) {
  getAllDefaultOptions = options;
}

export function getAllQueryKey(): QueryKey;
export function getAllQueryKey(...params: any[]): QueryKey {
  return trimArrayEnd([
      'HL7MessageTypeMappingClient',
      'getAll',
    ]);
}
export function __getAll(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getAll(
axiosConfig    );
}

/**
 * Gets all HL7 message type mappings.
 */
export function useGetAllQuery<TSelectData = Types.HL7MessageTypeMappingDto[], TError = unknown>(options?: Omit<UseQueryOptions<Types.HL7MessageTypeMappingDto[], TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetAllQuery<TSelectData = Types.HL7MessageTypeMappingDto[], TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.HL7MessageTypeMappingDto[], TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  

  options = params[0] as any;
  axiosConfig = params[1] as any;

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.HL7MessageTypeMappingDto[], TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getAll(context, axiosConfig) : __getAll,
    queryKey: getAllQueryKey(),
    ...getAllDefaultOptions as unknown as Omit<UseQueryOptions<Types.HL7MessageTypeMappingDto[], TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets all HL7 message type mappings.
 */
export function setGetAllData(queryClient: QueryClient, updater: (data: Types.HL7MessageTypeMappingDto[] | undefined) => Types.HL7MessageTypeMappingDto[], ) {
  queryClient.setQueryData(getAllQueryKey(),
    updater
  );
}

/**
 * Gets all HL7 message type mappings.
 */
export function setGetAllDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.HL7MessageTypeMappingDto[] | undefined) => Types.HL7MessageTypeMappingDto[]) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createUrl(): string {
  let url_ = getBaseUrl() + "/api/hl7/message-type-mappings";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createMutationKey(): MutationKey {
  return trimArrayEnd([
      'HL7MessageTypeMappingClient',
      'create',
    ]);
}

/**
 * Creates a HL7 message type mapping.
 * @param dto Request parameter
 */
export function useCreateMutation<TContext>(options?: Omit<UseMutationOptions<Types.HL7MessageTypeMappingDto, unknown, Types.CreateHL7MessageTypeMappingDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.HL7MessageTypeMappingDto, unknown, Types.CreateHL7MessageTypeMappingDto, TContext> {
  const key = createMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.CreateHL7MessageTypeMappingDto) => Client.create(dto),
    mutationKey: key,
  });
}
  
export function getSingleUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/hl7/message-type-mappings/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getSingleDefaultOptions: Omit<UseQueryOptions<Types.HL7MessageTypeMappingDto, unknown, Types.HL7MessageTypeMappingDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.HL7MessageTypeMappingDto, unknown, Types.HL7MessageTypeMappingDto>, 'queryFn'>> = {
};
export function getGetSingleDefaultOptions() {
  return getSingleDefaultOptions;
};
export function setGetSingleDefaultOptions(options: typeof getSingleDefaultOptions) {
  getSingleDefaultOptions = options;
}

export function getSingleQueryKey(id: number): QueryKey;
export function getSingleQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetSingleHL7MessageTypeMappingQueryParameters;

    return trimArrayEnd([
        'HL7MessageTypeMappingClient',
        'getSingle',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'HL7MessageTypeMappingClient',
        'getSingle',
        ...params
      ]);
  }
}
export function __getSingle(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getSingle(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetSingleQuery<TSelectData = Types.HL7MessageTypeMappingDto, TError = unknown>(dto: GetSingleHL7MessageTypeMappingQueryParameters, options?: Omit<UseQueryOptions<Types.HL7MessageTypeMappingDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets HL7 message type mapping by id.
 */
export function useGetSingleQuery<TSelectData = Types.HL7MessageTypeMappingDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.HL7MessageTypeMappingDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetSingleQuery<TSelectData = Types.HL7MessageTypeMappingDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.HL7MessageTypeMappingDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetSingleHL7MessageTypeMappingQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.HL7MessageTypeMappingDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getSingle(context, axiosConfig) : __getSingle,
    queryKey: getSingleQueryKey(id),
    ...getSingleDefaultOptions as unknown as Omit<UseQueryOptions<Types.HL7MessageTypeMappingDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets HL7 message type mapping by id.
 */
export function setGetSingleData(queryClient: QueryClient, updater: (data: Types.HL7MessageTypeMappingDto | undefined) => Types.HL7MessageTypeMappingDto, id: number) {
  queryClient.setQueryData(getSingleQueryKey(id),
    updater
  );
}

/**
 * Gets HL7 message type mapping by id.
 */
export function setGetSingleDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.HL7MessageTypeMappingDto | undefined) => Types.HL7MessageTypeMappingDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function patchUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/hl7/message-type-mappings/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function patchMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'HL7MessageTypeMappingClient',
      'patch',
      id as any,
    ]);
}

/**
 * Edits a hl7 message type mapping.
 * @param id The hl7 message type mapping id.
 * @param dto Request parameter
 */
export function usePatchMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, Types.PatchHL7MessageTypeMappingDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.PatchHL7MessageTypeMappingDto, TContext> {
  const key = patchMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (dto: Types.PatchHL7MessageTypeMappingDto) => Client.patch(id, dto),
    mutationKey: key,
  });
}
  
type Patch__MutationParameters = PatchHL7MessageTypeMappingQueryParameters & {
  dto: Types.PatchHL7MessageTypeMappingDto;
}

/**
 * Edits a hl7 message type mapping.
 * @param id The hl7 message type mapping id.
 * @param dto Request parameter
 */
export function usePatchMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Patch__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: PatchHL7MessageTypeMappingQueryParameters}): UseMutationResult<void, unknown, Patch__MutationParameters, TContext> {
  const key = patchMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Patch__MutationParameters) => Client.patch(data.id ?? options?.parameters?.id!, data.dto),
  mutationKey: key,
});
}
  
export function removeUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/hl7/message-type-mappings/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'HL7MessageTypeMappingClient',
      'remove',
      id as any,
    ]);
}

/**
 * Removes a HL7 message type mapping.
 * @param id The hl7 message type mapping id.
 */
export function useRemoveMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.remove(id),
    mutationKey: key,
  });
}
  
type Remove__MutationParameters = RemoveHL7MessageTypeMappingQueryParameters

/**
 * Removes a HL7 message type mapping.
 * @param id The hl7 message type mapping id.
 */
export function useRemoveMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, Remove__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveHL7MessageTypeMappingQueryParameters}): UseMutationResult<void, unknown, Remove__MutationParameters, TContext> {
  const key = removeMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: Remove__MutationParameters) => Client.remove(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}